import { IconProps } from '@/components/Icon';

export const IconEdit = ({ width = 24, height = 24, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 24 24' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7166 8.19873L6.96557 19.9517C6.41483 20.5027 5.73467 20.9079 4.98804 21.1304L2.30347 21.9302C2.2711 21.9398 2.2366 21.9404 2.20386 21.9321C2.1711 21.9238 2.14084 21.9072 2.11694 21.8833C2.09304 21.8594 2.07641 21.8292 2.06811 21.7964C2.05982 21.7636 2.06041 21.7292 2.07007 21.6968L2.86987 19.0122C3.09235 18.2656 3.49756 17.5854 4.04858 17.0347L15.8005 5.28272L18.7166 8.19873ZM19.8748 2.06299C20.4215 2.06299 20.946 2.28009 21.3328 2.66651C21.7195 3.05329 21.9373 3.57854 21.9373 4.12549C21.9372 4.60389 21.771 5.06524 21.4705 5.43213L21.3328 5.5835L20.574 6.34326L17.657 3.42627L18.4167 2.66651C18.8034 2.28 19.328 2.06306 19.8748 2.06299Z'
        fill={color}
        stroke={color}
        strokeWidth='1.125'
      />
    </svg>
  );
};
